import { Timestamp } from '@bufbuild/protobuf/wkt';
import { Severity } from '@wavingroup/aqora-v2-crate/wavin/aqora/v2/event_pb';
import {
  Issue,
  Issue_ResourceType,
  IssueStatus,
  IssueType,
} from '@wavingroup/aqora-v2-crate/wavin/aqora/v2/issue_pb';
import { ResourceNameIdConverter } from '~/shared/models/ResourceNameIdConverter';

export class IssueModel {
  readonly resourceName: string;

  readonly type: IssueType;

  readonly severity: Severity;

  readonly firstOccurrenceTime?: Timestamp;

  readonly lastOccurrenceTime?: Timestamp;

  readonly systemTitle: string;

  readonly resourceType: Issue_ResourceType;

  readonly resourceTitle: string;

  readonly systemId: string;

  readonly status: IssueStatus;

  readonly canBeSolvedManually: boolean;

  constructor(issue: Issue) {
    this.resourceName = issue.resourceName;
    this.type = issue.issueType;
    this.severity = issue.severity;
    this.firstOccurrenceTime = issue.firstOccurrenceTime;
    this.lastOccurrenceTime = issue.lastOccurrenceTime;
    this.systemTitle = issue.systemTitle;
    this.resourceType = issue.resourceType;
    this.status = issue.status;
    this.systemId = ResourceNameIdConverter.systemNameToId(issue.resourceName);
    this.status = issue.status;
    this.resourceTitle = issue.resourceTitle;
    this.canBeSolvedManually = this.getCanBeSolvedManually();
  }

  getCanBeSolvedManually(): boolean {
    switch (this.type) {
      case IssueType.TAP_BROKEN:
      case IssueType.PUMP_BROKEN:
      case IssueType.DRAIN_CLOGGED:
      case IssueType.OVERFLOW_DRAIN_CLOGGED:
      case IssueType.RAIN_SENSOR_DATA_MISMATCH:
      case IssueType.OVERFLOW_HEIGHT_TO_LOW:
      case IssueType.WATER_HEIGHT_SENSOR_FLUCTUATIONS:
        return true;
      default:
        return false;
    }
  }
}
